<template>
    <FormModal :model="model" :init="init" modal-id="user" :is-enabled-view-mode="false">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['user/level2variant'](model.level)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'users.level.' + model.level
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-form-group
                    label-cols-sm="2"
                    label="権限"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-radio-group v-model="model.level" size="sm">
                        <b-form-radio value="000">なし</b-form-radio>
                        <b-form-radio value="001">保険会社</b-form-radio>
                        <b-form-radio value="101">デモ</b-form-radio>
                        <b-form-radio value="100">一般</b-form-radio>
                        <b-form-radio value="200">一般まとめ</b-form-radio>
                        <b-form-radio value="300">管理者</b-form-radio>
                    </b-form-radio-group>
                    <input-error :errors="error.level" />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="機能"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <small>在庫連携</small>
                    <div class="mb-2">
                        <b-form-checkbox
                            v-model="model.functions['sync']"
                            :value="true" :unchecked-value="false"
                            class="d-inline"
                            >
                            在庫連携
                        </b-form-checkbox>
                    </div>
                    <small>Easy Card Lister</small>
                    <div class="mb-2">
                        <b-form-checkbox
                            v-model="model.functions['ecl.pokemon']"
                            :value="true" :unchecked-value="false"
                            class="d-inline"
                            >
                            Pokemon
                        </b-form-checkbox>
                        &emsp;
                        <b-form-checkbox
                            v-model="model.functions['ecl.yugioh']"
                            :value="true" :unchecked-value="false"
                            class="d-inline"
                            >
                            Yugioh
                        </b-form-checkbox>
                    </div>
                    <small>ラベル作成</small>
                    <div class="mb-2">
                        <b-form-checkbox
                            v-model="model.functions['shipping.shipper_maker']"
                            :value="true" :unchecked-value="false"
                            class="d-inline"
                            >
                            Shipper Maker
                        </b-form-checkbox>
                        &emsp;
                        <b-form-checkbox
                            v-model="model.functions['shipping.ecms']"
                            :value="true" :unchecked-value="false"
                            class="d-inline"
                            >
                            ECMS
                        </b-form-checkbox>
                    </div>
                    <small>ストレージ</small>
                    <div class="mb-2">
                        <b-form-checkbox
                            v-model="model.functions['storage.ecrobo_order_attached_file']"
                            :value="true" :unchecked-value="false"
                            class="d-inline"
                            >
                            ECRobo出荷指示添付ファイル
                        </b-form-checkbox>
                    </div>
                    <div class="text-muted">※管理者はすべて有効になります。変えられません。</div>
                    <input-error :errors="error.functions" />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="まとめ親"
                    label-size="sm"
                    @submit.stop.prevent
                    v-if="[ '000', '100', ].includes(model.level)"
                    >
                    <SelectUserManager
                        v-model="model.user_manager_id"
                        size="sm"
                        />
                    <input-error :errors="$utils.get(error, 'profile_address_prefecture')" />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="メール"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.email"
                        size="sm"
                        placeholder="email@example.com"
                        ></b-form-input>
                    <input-error :errors="error.email" />
                </b-form-group>
            </template>
            <template v-else>
                <div class="mb-3">
                    <p class="mb-1">
                        <b-badge
                            :variant="$store.getters['user/level2variant'](model.level)"
                            >
                            {{
                            trans.labels[
                            'users.level.' + model.level
                            ]
                            }}
                        </b-badge>
                    </p>

                    <div>
                        <a :href="'mailto:' + model.email">{{ model.email }}</a>
                    </div>
                </div>
            </template>

                <b-form-group
                    label-cols-sm="2"
                    label="登記情報"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <UserProfileContent
                        v-model="model.profile"
                        :error="error"
                        />
<!---
                    <InsuranceTable
                        ref="table"
                        mode="register"
                        style-height="8em"
                        />
                    <input-error :errors="error.profile" />
-->
                </b-form-group>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'
import InsuranceTable from '@/components/InsuranceTable.vue'
import UserProfileContent from '@/components/UserProfileContent.vue'
import SelectUserManager from '@/components/SelectUserManager.vue'

export default {
    components: {
        FormModal,
        InputError,
        InsuranceTable,
        UserProfileContent,
        SelectUserManager,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>


